<template>
  <div class="main sendMain">
    <!-- 顶部 -->
    <div class="top">
      <img class="goback" src="../assets/back.png" @click="goback" />
      <span>返回</span>
      <img class="process" src="../assets/process3.jpg" />
    </div>
    <!-- 下部分 -->
    <div class="sendText">
      <p>是否将申报表(一式两份)、承诺书(一式两份)、技术说明材料，主申报单位、联合申报单位、业主单位相关资质文件（营业执照、资质证书等）</p>
      <br />
      <p>寄送至协会(宛平南路75号1号楼902室，周翀，64878019)?</p>
    </div>
    <div style="text-align: center;">
      <el-button type="primary" plain @click="yesSave" style="margin-right: 20px">否，保存</el-button>
      <el-button type="primary" @click="submit">是，提交项目</el-button>
    </div>
  </div>
</template>

<script>
import * as API from '../utils/apiService'
export default {
  data () {
    return {}
  },
  methods: {
    goback () {
      this.$router.go(-1)
    },
    submit () {
      let params = {
        id: this.$route.query.id
      }
      API.updateSendstate(params).then(resp => {
        if (resp.resultCode === '0000') {
          this.$message.success('提交成功！')
          this.$router.push('/declare/waiting')
        }
      })
    },
    yesSave () {
      this.$router.push('/declare/waiting')
    }
  }
}
</script>

<style lang="scss">
.sendMain {
  .sendText {
    margin: 120px 0 50px;
    text-align: center;
    color: #f00;
    font-size: 26px;
  }
}
</style>
